import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";

import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Operations from "@/pages/Operations";
import Finance from "@/pages/Finance";
import ParkingMap from "@/pages/ParkingMap";
import LiveMap from "@/pages/LiveMap";
import Slots from "@/pages/Slots";
import Vehicles from "@/pages/Vehicles";
import Sessions from "@/pages/Sessions";
import Visitors from "@/pages/Visitors";
import Wallet from "@/pages/Wallet";
import Audit from "@/pages/Audit";
import Billing from "@/pages/Billing";
import Residents from "@/pages/Residents";
import Blacklist from "@/pages/Blacklist";
import Violations from "@/pages/Violations";

function Private() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Layout><Outlet /></Layout>;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Private />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/operations" element={<Operations />} />
            <Route path="/finance" element={<Finance />} />
            <Route path="/map" element={<ParkingMap />} />
            <Route path="/live-map" element={<LiveMap />} />
            <Route path="/slots" element={<Slots />} />
            <Route path="/vehicles" element={<Vehicles />} />
            <Route path="/sessions" element={<Sessions />} />
            <Route path="/visitors" element={<Visitors />} />
            <Route path="/wallet" element={<Wallet />} />
            <Route path="/audit" element={<Audit />} />
            <Route path="/billing" element={<Billing />} />
            <Route path="/residents" element={<Residents />} />
            <Route path="/blacklist" element={<Blacklist />} />
            <Route path="/violations" element={<Violations />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
